import api from '.';
import {getCurrentLocale} from '../../utils/i18n';

export const searchAsync = async (term, catalog) => {
    let query = `{ search(query: "${term}", language: ${getCurrentLocale().toUpperCase()}, catalog: ${catalog}) { __typename ... on Show { id title image } __typename ... on Game { id title showName image }}}`;
    try {
        let response = await api.get('', {
            params: {
                query,
            },
        });

        if (response.data.data.search) {
            return response.data.data.search;
        }
        throw new Error('Search failed');
    } catch (error) {
        console.log(error);
        throw new Error('Search failed');
    }
};
